// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3011":"2670caaca7d6fb21","7708":"f14bfe0590138caa"}[chunkId] + ".js";
};